import { AutogenModelJournalCash, AutogenRowJournalCash } from "./autogen/AutogenModelJournalCash";

export class ModelJournalCash extends AutogenModelJournalCash<RowJournalCash> {
	constructor() {
		super(RowJournalCash);
	}
}

export class RowJournalCash extends AutogenRowJournalCash {
}